module.exports = __webpack_public_path__ + "img/oem3.79d3065a.png";